import React from 'react';
import { ArrowDown, Download, Mail, Github, Linkedin, Twitter } from 'lucide-react';
import profile from '../../assets/profile.png';
const Hero = () => {
  const scrollToAbout = () => {
    const aboutSection = document.getElementById('about');
    if (aboutSection) {
      aboutSection.scrollIntoView({ behavior: 'smooth' });
    }
  };

  const scrollToContact = () => {
    const contactSection = document.getElementById('contact');
    if (contactSection) {
      contactSection.scrollIntoView({ behavior: 'smooth' });
    }
  };

  const socialLinks = [
    { icon: Github, href: 'https://github.com/Nithinreddy000', label: 'GitHub' },
    { icon: Linkedin, href: 'https://www.linkedin.com/in/nithin-reddy1/', label: 'LinkedIn' },
  ];

  return (
    <section 
      id="home" 
      style={{ 
        minHeight: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        background: 'linear-gradient(135deg, #FFFFFF 0%, #D1F0E0 50%, #96C7B9 100%)',
        padding: '2rem 0',
        position: 'relative'
      }}
    >
      <div style={{ maxWidth: '1200px', margin: '5rem auto', padding: '0 1rem', position: 'relative', zIndex: 10 }}>
        <div style={{ textAlign: 'center', maxWidth: '800px', margin: '0 auto' }}>
          
          {/* Avatar */}
          <div style={{ marginBottom: '2rem', display: 'flex', justifyContent: 'center' }}>
            <div style={{ position: 'relative' }}>
              <div 
                style={{ 
                  width: '160px', 
                  height: '160px', 
                  background: 'linear-gradient(135deg, #96C7B9 0%, #7BB5A7 100%)',
                  borderRadius: '50%',
                  padding: '4px',
                  boxShadow: '0 0 20px rgba(150, 199, 185, 0.4)'
                }}
              >
                <div 
                  style={{ 
                    width: '100%', 
                    height: '100%', 
                    borderRadius: '50%', 
                    backgroundColor: '#D1F0E0',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    overflow: 'hidden'
                  }}
                >
                  <img 
                    src={profile}
                    alt="Nithin Reddy" 
                    style={{ width: '100%', height: '100%', objectFit: 'cover', borderRadius: '50%' }}
                  />
                </div>
              </div>
            </div>
          </div>

          {/* Name and Title */}
          <div style={{ marginBottom: '2rem' }}>
            <h1 style={{ 
              fontFamily: 'Comfortaa, sans-serif',
              fontSize: 'clamp(2.5rem, 8vw, 4rem)',
              fontWeight: '700',
              lineHeight: '1.1',
              color: '#2C3E50',
              marginBottom: '1rem'
            }}>
              Hi, I'm{' '}
              <span style={{ 
                background: 'linear-gradient(135deg, #96C7B9 0%, #7BB5A7 100%)',
                WebkitBackgroundClip: 'text',
                WebkitTextFillColor: 'transparent',
                backgroundClip: 'text'
              }}>
                Nithin Reddy
              </span>
            </h1>
            
            <div style={{ display: 'flex', flexWrap: 'wrap', justifyContent: 'center', gap: '0.5rem', marginBottom: '1rem' }}>
              <span style={{ 
                display: 'inline-block',
                padding: '0.5rem 1rem',
                backgroundColor: 'rgba(150, 199, 185, 0.1)',
                border: '1px solid rgba(150, 199, 185, 0.3)',
                borderRadius: '25px',
                color: '#96C7B9',
                fontWeight: '500'
              }}>
                Full Stack Developer
              </span>
              <span style={{ 
                display: 'inline-block',
                padding: '0.5rem 1rem',
                backgroundColor: 'rgba(150, 199, 185, 0.2)',
                border: '1px solid rgba(150, 199, 185, 0.5)',
                borderRadius: '25px',
                color: '#546C81',
                fontWeight: '500'
              }}>
                Flutter Developer
              </span>
              <span style={{ 
                display: 'inline-block',
                padding: '0.5rem 1rem',
                backgroundColor: 'rgba(150, 199, 185, 0.2)',
                border: '1px solid rgba(150, 199, 185, 0.5)',
                borderRadius: '25px',
                color: '#546C81',
                fontWeight: '500'
              }}>
                React js
              </span>
              <span style={{ 
                display: 'inline-block',
                padding: '0.5rem 1rem',
                backgroundColor: 'rgba(150, 199, 185, 0.2)',
                border: '1px solid rgba(150, 199, 185, 0.5)',
                borderRadius: '25px',
                color: '#546C81',
                fontWeight: '500'
              }}>
                Aws & Google Cloud
              </span>
            </div>
          </div>

          {/* Description */}
          <p style={{ 
            fontSize: '1.2rem',
            color: '#546C81',
            maxWidth: '600px',
            margin: '0 auto 2rem auto',
            lineHeight: '1.6'
          }}>
            I create exceptional digital experiences that combine beautiful design with robust functionality. 
            Passionate about modern web technologies and user-centered design principles.
          </p>

          {/* CTA Buttons */}
          <div style={{ display: 'flex', flexDirection: 'column', gap: '1rem', justifyContent: 'center', marginBottom: '3rem' }}>
            <div style={{ display: 'flex', flexWrap: 'wrap', gap: '1rem', justifyContent: 'center' }}>
              <button
                onClick={scrollToContact}
                style={{ 
                  display: 'inline-flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  gap: '0.5rem',
                  padding: '1rem 2rem',
                  fontSize: '1.1rem',
                  fontWeight: '600',
                  background: 'linear-gradient(135deg, #96C7B9 0%, #7BB5A7 100%)',
                  color: '#FFFFFF',
                  border: 'none',
                  borderRadius: '8px',
                  boxShadow: '0 4px 15px rgba(150, 199, 185, 0.3)',
                  minWidth: '200px',
                  cursor: 'pointer',
                  transition: 'all 0.3s ease'
                }}
                onMouseOver={(e) => {
                  e.target.style.transform = 'scale(1.05)';
                  e.target.style.boxShadow = '0 6px 20px rgba(150, 199, 185, 0.4)';
                }}
                onMouseOut={(e) => {
                  e.target.style.transform = 'scale(1)';
                  e.target.style.boxShadow = '0 4px 15px rgba(150, 199, 185, 0.3)';
                }}
              >
                <Mail size={20} />
                Get In Touch
              </button>
              
              <a
                href="https://drive.google.com/file/d/1ZbMNhKY4Z8zLsDf3B6D53_mus-2ojZBU/view?usp=sharing"
                target="_blank"
                rel="noopener noreferrer"
                style={{ 
                  display: 'inline-flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  gap: '0.5rem',
                  padding: '1rem 2rem',
                  fontSize: '1.1rem',
                  fontWeight: '600',
                  background: 'transparent',
                  color: '#96C7B9',
                  border: '2px solid #96C7B9',
                  borderRadius: '8px',
                  textDecoration: 'none',
                  minWidth: '200px',
                  cursor: 'pointer',
                  transition: 'all 0.3s ease'
                }}
                onMouseOver={(e) => {
                  e.target.style.transform = 'scale(1.05)';
                  e.target.style.backgroundColor = '#96C7B9';
                  e.target.style.color = '#FFFFFF';
                }}
                onMouseOut={(e) => {
                  e.target.style.transform = 'scale(1)';
                  e.target.style.backgroundColor = 'transparent';
                  e.target.style.color = '#96C7B9';
                }}
              >
                <Download size={20} />
                Download Resume
              </a>
            </div>
          </div>

          {/* Social Links */}
          <div style={{ display: 'flex', justifyContent: 'center', gap: '1.5rem', marginBottom: '3rem' }}>
            {socialLinks.map((social, index) => {
              const Icon = social.icon;
              return (
                <a
                  key={social.label}
                  href={social.href}
                  target="_blank"
                  rel="noopener noreferrer"
                  style={{ 
                    padding: '1rem',
                    borderRadius: '50%',
                    backgroundColor: 'rgba(255, 255, 255, 0.8)',
                    border: '2px solid rgba(150, 199, 185, 0.5)',
                    boxShadow: '0 4px 15px rgba(0, 0, 0, 0.1)',
                    cursor: 'pointer',
                    transition: 'all 0.3s ease'
                  }}
                  onMouseOver={(e) => {
                    e.target.style.transform = 'scale(1.1)';
                    e.target.style.borderColor = '#96C7B9';
                  }}
                  onMouseOut={(e) => {
                    e.target.style.transform = 'scale(1)';
                    e.target.style.borderColor = 'rgba(150, 199, 185, 0.5)';
                  }}
                >
                  <Icon size={24} style={{ color: '#546C81' }} />
                </a>
              );
            })}
          </div>

          {/* Scroll Indicator */}
          <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
            <p style={{ fontSize: '1rem', color: '#546C81', marginBottom: '1rem', fontWeight: '500' }}>
              Discover more about me
            </p>
            <button
              onClick={scrollToAbout}
              style={{ 
                padding: '1rem',
                borderRadius: '50%',
                backgroundColor: 'rgba(255, 255, 255, 0.8)',
                border: '2px solid rgba(150, 199, 185, 0.5)',
                boxShadow: '0 4px 15px rgba(0, 0, 0, 0.1)',
                cursor: 'pointer',
                transition: 'all 0.3s ease'
              }}
              onMouseOver={(e) => {
                e.target.style.transform = 'scale(1.1)';
                e.target.style.borderColor = '#96C7B9';
              }}
              onMouseOut={(e) => {
                e.target.style.transform = 'scale(1)';
                e.target.style.borderColor = 'rgba(150, 199, 185, 0.5)';
              }}
            >
              <ArrowDown size={24} style={{ color: '#96C7B9' }} />
            </button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;